import { useApplicationData } from '@provider';
import { Box } from '@spark-web/box';
import { Columns } from '@spark-web/columns';
import { Row } from '@spark-web/row';
import { Stack } from '@spark-web/stack';
import { Text } from '@spark-web/text';
import { LOAN_CONTRACT } from '@utils';
import { useApplicationDetails } from './hooks';

const tableBorder = 'fieldDisabled';

function LoanScheduleTable() {
  const { LOAN_SCHEDULE } = LOAN_CONTRACT;
  const { application, quote } = useApplicationData(['application', 'quote']);
  const loanTableData = useApplicationDetails({ application, quote });

  return (
    <Box data-testid="loan-schedule-table">
      <Stack paddingBottom="large" paddingTop="xsmall">
        <Text weight="semibold" size="small">
          {LOAN_SCHEDULE}
        </Text>
      </Stack>
      <Stack border={tableBorder}>
        {loanTableData.map(({ title, items }) => (
          <Stack key={title}>
            <Columns borderBottom={tableBorder} gap="medium" padding="medium">
              <Text weight="semibold" size="xsmall">
                {title}
              </Text>
            </Columns>
            {items.map(({ label, value, symbol, description }) => (
              <Box borderBottom={tableBorder} key={label}>
                {value ? (
                  <Columns gap="large" template={[3, 1]}>
                    <Row gap="xlarge" padding="large">
                      <Text size="xsmall" overflowStrategy="breakword">
                        {label}{' '}
                        <Box as="sup" asElement="sup">
                          {symbol}
                        </Box>
                        {description && <Text>{description}</Text>}
                      </Text>
                    </Row>
                    <Row gap="medium" padding="medium" borderLeft={tableBorder} height="full">
                      <Text size="xsmall" overflowStrategy="breakword">
                        {value}
                      </Text>
                    </Row>
                  </Columns>
                ) : (
                  <Stack gap="xlarge" padding="large">
                    <Text size="xsmall" overflowStrategy="breakword">
                      {label}
                      {description && <Text>{description}</Text>}
                    </Text>
                  </Stack>
                )}
              </Box>
            ))}
          </Stack>
        ))}
      </Stack>
    </Box>
  );
}

export default LoanScheduleTable;
